import AsyncStorage from "@react-native-async-storage/async-storage";
import React, { Fragment, useEffect, useState } from "react";
import { Pressable, ScrollView, Text, View } from "react-native";
import Modal from "react-native-modal";
import { useTranslation } from "react-i18next";
import {
  ArrowLeft,
  CheckIcon,
  ChevronDown,
  CloseCircleIcon,
  SearchBoldIcon,
  TickCircleIcon,
} from "../assets/icons";
import EmptyState from "./EmptyState";
import { getOptions } from "../services/survey";
import i18n from "../translation/index";

function ModalMenuMultipleDropdownSubquestion(props) {
  const { t } = useTranslation(); 
  const { onChange, value, options, placeholder, quizType, filteredFromAnswer, answer, filteredToAnswer, question, noOptionPlaceholder, setListChosenAll, listChosenAll, data } = props;
  const [visible, setVisible] = useState(false);
  const [search, setSearch] = useState("");
  const [filteredOptions, setFilteredOptions] = useState([]);
  const [loadingOptions, setLoadingOptions] = useState(false);
  const [additionalOptions, setAdditionalOptions] = useState([]);
  const [tempValue, setTempValue] = useState([]);
  const [allSelected, setAllSelected] = useState(undefined);

  useEffect(() => {
      if (answer[data.rowId]) {
        setTempValue(answer[data.rowId].split(", "));
      }
    }, []);

  useEffect(() => {
    if (!allSelected) {
      return;
    }
    if (listChosenAll.indexOf(data.orderNo) > -1) {
      const newChosenAll = listChosenAll.filter((a) => a !== data.orderNo);
      setListChosenAll(newChosenAll);
    } else {
      setListChosenAll([...listChosenAll, data.orderNo]);
    }
  }, [allSelected]);

  useEffect(() => {
    if (!visible) {
      return;
    }
    if (!Array.isArray(options) && options.indexOf(".json") > -1) {
      setLoadingOptions(true);
      setTimeout(() => {
        getOptions(options.replace(".json", ""))
        .then((res) => {
          setTimeout(() => {
            // since the value can be multiple, 
            // then the filtered value will be detected based on index
            let filteredOptions = res?.data.options;
            if (filteredFromAnswer?.length > 0) {
              filteredFromAnswer.map((fA) => {
                filteredOptions = filteredOptions.filter((o) => answer[fA]?.indexOf(o) < 0);
              });
            }

            if (filteredToAnswer?.length > 0 && quizType == "data_source_associate") {
              const rawData = JSON.parse(res?.data.options);
              filteredOptions = rawData[Object.keys(rawData).filter((o) => answer[filteredToAnswer[0]]?.indexOf(o) >= 0)] ?? [];
            }

            if (noOptionPlaceholder) {
              filteredOptions = [noOptionPlaceholder, ...filteredOptions];
            }

            if (filteredFromAnswer?.length > 0 && quizType === "data_source_multiple_no_option") {
              if (filteredOptions.length === 1 && filteredOptions[0] === noOptionPlaceholder) {
                setTempValue(filteredOptions)
              }
            }
            setAdditionalOptions(filteredOptions);
            setLoadingOptions(false);
          }, 1000);
        });
      }, 500);
    }
  }, [options, visible]);

  useEffect(() => {
    if (search?.length === 0) {
      return setFilteredOptions(additionalOptions);
    }
    const filtered = additionalOptions.filter((p) =>
      search?.length > 0 ? p.toLowerCase().includes(search.toLowerCase()) : true
    );
    setFilteredOptions(filtered);
  }, [search, additionalOptions]);

  useEffect(() => {
    async function getLang() {
      return await AsyncStorage.getItem("lang");
    }

    getLang()
    .then((res) => {
      if (!res) {
        AsyncStorage.setItem("lang", "id");
        i18n.changeLanguage("id");
        return;
      }
      AsyncStorage.setItem("lang", res);
      i18n.changeLanguage(res);
    });
  }, []);

  return (
    <Fragment>
      <Pressable
        style={{
          borderRadius: 10,
          borderWidth: 1,
          borderColor: "#999",
          borderStyle: "solid",
          backgroundColor: "#FFF",
          padding: 12,
        }}
        onPress={() => {
          setVisible(true);
        }}
      >
        <View
         style={{
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "space-between",
         }}
        >
          <Text
            style={{
              color: "#000",
              fontFamily: "Archivo-Regular",
              fontSize: 12,
              fontStyle: "normal",
              fontWeight: 500,
            }}
          >
            { question }
          </Text>
          <ChevronDown />
        </View>
        {
          value && 
          <View style={{marginTop: 12}}>
            <Text
              style={{
                color:  "#999",
                fontFamily: "Archivo-Regular",
                fontSize: 12,
                fontStyle: "normal",
                fontWeight: 500,
              }}
            >
            {value}
            </Text>
        </View>
        }
      </Pressable>
      <Modal
        style={{
          padding: 0,
          width: "100%", 
          height: "100%", 
          margin: 0,
          maxWidth: "400px",
          marginLeft: "auto",
          marginRight: "auto"
        }}
        isVisible={visible}
        onBackdropPress={() => {
          setFilteredOptions([]);
          setAdditionalOptions([]);
          setVisible(false);
        }}
      >
        <View
          style={{
            width: "100%",
            backgroundColor: "#FFFFFF",
            borderRadius: 10,
            height: "100%"
          }}
        >
          <View
            style={{
              paddingTop: 16,
              paddingBottom: 16,
              paddingLeft: 12,
              paddingRight: 12,
              flexDirection: "row",
              justifyContent: "space-between",
            }}
          >
            <View
              style={{
                flexDirection: "row",
                justifyContent: "space-between",
                gap: 12
              }}>
              <Pressable
                onPress={() => {
                  setFilteredOptions([]);
                  setAdditionalOptions([]);
                  setVisible(false);
                }}
              >
                  <ArrowLeft/>
                </Pressable>
              <Text
                style={{
                  color: "#000",
                  fontFamily: "Archivo-Bold",
                  fontSize: 12,
                  fontStyle: "normal",
                  fontWeight: 700,
                  lineHeight: 14,
                }}
              >
                {t("survey:header-select")}
              </Text>
            </View>
            {
              (quizType !== "data_source_multiple" && quizType !== "data_source_associate" && quizType !== "data_source_multiple_no_option") &&
              <Pressable
                onPress={() => {
                  setFilteredOptions([]);
                  setAdditionalOptions([]);
                  setVisible(false);
                }}
              >
                <CloseCircleIcon />
              </Pressable>
            }
            {
              (quizType === "data_source_multiple" || quizType === "data_source_associate" || quizType == "data_source_multiple_no_option") &&
              <Pressable
                onPress={() => {
                  if (allSelected) {
                    setTempValue([]);
                    setAllSelected(false);
                    return;
                  }
                  if (noOptionPlaceholder) {
                    setTempValue(filteredOptions.filter((a) => a !== noOptionPlaceholder));
                  } else {
                    setTempValue(filteredOptions);
                  }
                  setAllSelected(true);
                }}
                style={{
                  background: "#FFF", 
                  paddingHorizontal: "8px",
                  paddingVertical: "9px",
                  alignItems: "center",
                  borderRadius: "16px",
                  border: "solid 1px #EAEAEA",
                  flexDirection: "row",
                  gap: "6px"
                }}
              >
                  <CheckIcon fill={allSelected && (typeof allSelected !== "undefined") ? "#FF0000" : "#6724E2"} />
                  <Text style={{color: allSelected && (typeof allSelected !== "undefined") ? "#FF0000" : "#6724E2", fontFamily: "Archivo-Medium", fontSize: 12}}>
                    {
                      allSelected ?
                      t("survey:button-unselect-all") :
                      t("survey:button-select-all")
                    }
                  </Text>
              </Pressable>
            }
          </View>
          {
            loadingOptions &&
            <EmptyState
                  Icon={SearchBoldIcon}
                  title={t("survey:caption-loading-title")}
                  desc={t("survey:caption-loading-subtitle")}
                />
          }
          {
            !loadingOptions &&
            <ScrollView style={{height: "100%", padding: 16}}>
              {filteredOptions?.length > 0 ? (
                filteredOptions.map((item, i) => {
                  let p = item;
                  let code = [];
                  if (item.indexOf(") ") > -1) {
                    code = item.split(") "); 
                  }
                  return (
                  <Pressable
                      onPress={() => {
                        if (quizType === "data_source") {
                          setTempValue([p]);
                          return;
                        }

                        if (tempValue.indexOf(p) < 0) {
                          setTempValue([
                            ...tempValue,
                            p
                          ]);

                          return;
                        } 
                        const newTempValue = tempValue.filter((v) => {
                          return v !== p;
                        });

                        const newChosenAll = listChosenAll.filter((a) => a !== data.orderNo);
                        setListChosenAll(newChosenAll);

                        setTempValue(newTempValue);
                      }}
                    >
                      <View
                        style={{
                          borderRadius: 10,
                          padding: 12,
                          borderWidth: 1,
                          borderColor: tempValue.indexOf(p) > -1 ? "#6724E2" : "#EAEAEA",
                          flexDirection: "row",
                          justifyContent: "flex-start",
                          gap: 10,
                          alignItems: "center",
                          marginBottom: i === filteredOptions.length - 1 ? 20: 12
                        }}
                      >
                        <div style={{width: "22px", height: "22px"}}>
                        {
                          tempValue.indexOf(p) > -1 ? <TickCircleIcon fill={true}/> : <TickCircleIcon/>
                        }
                        </div>
                        {
                          code.length > 0 &&
                          <Text
                            style={{
                              backgroundColor: tempValue.indexOf(p) > -1 ? "#6724E2" : "#000",
                              fontFamily: "Archivo-Regular",
                              fontSize: 12,
                              fontStyle: "normal",
                              fontWeight: 400,
                              lineHeight: 14,
                              color: "#FFF",
                              paddingVertical: 4,
                              paddingHorizontal: 10,
                              borderRadius: 10
                            }}
                          >
                            {`${code[0].replace("(", "")}`}
                          </Text> 
                        }
                        <Text
                          style={{
                            color: tempValue.indexOf(p) > -1 ? "#6724E2" : "#000",
                            fontFamily: "Archivo-Regular",
                            fontSize: 12,
                            fontStyle: "normal",
                            fontWeight: 400,
                            lineHeight: 14,
                          }}
                        >
                          { code.length > 1 ? code[1] : p}
                        </Text>
                      </View>
                    </Pressable>
                  );
                })
              ) : (
                <EmptyState
                  Icon={SearchBoldIcon}
                  title="Jawaban Tidak Ditemukan"
                  desc="Gunakan kata kunci yang lain untuk mencari jawaban"
                />
              )}
              </ScrollView>
          }
          <View
            style={{
              padding: 16,
              borderTopWidth: 1,
              borderTopColor: "#EAEAEA",
              justifyContent: "center",
              flexDirection: "row",
              gap: 16
            }}
          >
            <Pressable 
              style={{width: "50%",}}
              onPress={() => {
                if (tempValue.length < 1) {
                  onChange("");
                }
                setFilteredOptions([]);
                setAdditionalOptions([]);
                setVisible(false);
              }}
            >
              <View style={{
                padding: 12,
                borderWidth: 1,
                borderColor: "#999",
                alignItems: "center",
                background: "#FFF",
                color: "#000",
                borderRadius: 10,
                width: "100%"
              }}>
                <Text style={{fontFamily: "Archivo-Bold", fontSize: 12}}>{t("survey:button-back")}</Text>
              </View>
            </Pressable>
            <Pressable 
              style={{width: "50%"}}
              onPress={() => {
                if (tempValue.length < 1) {
                  return;
                }

                if (quizType === "data_source_multiple" || quizType === "data_source_associate" || quizType == "data_source_multiple_no_option") {
                  onChange(tempValue.join(", "));
                } else {
                  onChange(tempValue[0]);
                }

                setFilteredOptions([]);
                setAdditionalOptions([]);
                setVisible(false);
              }}
            >
              <View style={{
                padding: 12,
                alignItems: "center",
                background: tempValue.length > 0 ? "#6724E2" : "#999",
                borderRadius: 10,
                width: "100%"
              }}>
                <Text style={{color: "#FFF", fontFamily: "Archivo-Bold", fontSize: 12}}>{t("survey:button-save-data")}</Text>
              </View>
            </Pressable>
          </View>
        </View>
      </Modal>
    </Fragment>
  );
}

export default ModalMenuMultipleDropdownSubquestion;
